exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".config-dashboard {\n  margin: auto;\n  width: 700px; }\n  .config-dashboard mat-icon {\n    color: #BDBDBD; }\n  .config-dashboard mat-form-field {\n    width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/admin/components/config-panel/config-panel.component.scss
// module id = ../../../../../src/app/components/admin/components/config-panel/config-panel.component.scss
// module chunks = main